
export default {
  name: 'LayoutCard',

  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  computed: {
    items: function () {
      let list = [];

      console.log('this.item: ', this.item);

      if (this.item?.square) {
        list.push({
          title: 'Площадь',
          value: this.item?.square
        });
      }
      if (this.item?.floor) {
        list.push({
          title: 'Этаж',
          value: this.item?.floor
        });
      }
      if (this.item?.price) {
        list.push({
          title: 'Цена',
          value: ['от', this.$numberFormat(this.item?.price), '₽'].join(' ')
        });
      }

      return list;
    }
  }
};
